$(document).ready(function() {
  // scan in manually page event session admin pages
  $("#input-abo-number").keyup(function() {
    $.ajax({
      type: "GET",
      dataType:"json",
      data: { "abo_number" : $(this).val() },
      url: "/api/services/get_account_with_abo",
      success: function(response){
        $("#abo_name").val(response.recognition_name)
      }
    })
  })

  // remove error message on form pages
  $('form').on('submit', function(){
    setTimeout(() => {
      $('#remove-validation-content-ch').find('#error-message').remove()
    }, 100);
  })

  // Summernote
  $('form').on('submit', function() {
    $("[id^='note-dialog-image-file-']").attr('name', 'note-files');
  })

  $('#office_number_validation').change(function() {
    var text_length = $(this).val().length
    var get_id      = '#office_number_code'

    validationPhoneNumber(text_length, get_id)
  })

  $('#office_number_validation').keyup(function() {
    var text_length = $(this).val().length
    var get_id      = '#office_number_code'

    validationPhoneNumber(text_length, get_id)
  })

  $('#office_number_code').change(function() {
    var text_length = $(this).val().length
    var get_id      = '#office_number_validation'

    validationPhoneNumber(text_length, get_id)
  })

  $('#office_number_code').keyup(function() {
    var text_length = $(this).val().length
    var get_id      = '#office_number_validation'

    validationPhoneNumber(text_length, get_id)
  })

  $('#mobile_phone_2_validation').change(function() {
    var text_length = $(this).val().length
    var get_id      = '#mobile_phone_2_code'

    validationPhoneNumber(text_length, get_id)
  })

  $('#mobile_phone_2_validation').keyup(function() {
    var text_length = $(this).val().length
    var get_id      = '#mobile_phone_2_code'

    validationPhoneNumber(text_length, get_id)
  })

  $('#mobile_phone_2_code').change(function() {
    var text_length = $(this).val().length
    var get_id      = '#mobile_phone_2_validation'

    validationPhoneNumber(text_length, get_id)
  })

  $('#mobile_phone_2_code').keyup(function() {
    var text_length = $(this).val().length
    var get_id      = '#mobile_phone_2_validation'

    validationPhoneNumber(text_length, get_id)
  })

  $('#home_number_validation').change(function() {
    var text_length = $(this).val().length
    var get_id      = '#home_number_code'

    validationPhoneNumber(text_length, get_id)
  })

  $('#home_number_validation').keyup(function() {
    var text_length = $(this).val().length
    var get_id      = '#home_number_code'

    validationPhoneNumber(text_length, get_id)
  })

  $('#home_number_code').change(function() {
    var text_length = $(this).val().length
    var get_id      = '#home_number_validation'

    validationPhoneNumber(text_length, get_id)
  })

  $('#home_number_code').keyup(function() {
    var text_length = $(this).val().length
    var get_id      = '#home_number_validation'

    validationPhoneNumber(text_length, get_id)
  })

  function validationPhoneNumber(phone_number, get_id) {
    console.log(phone_number)
    if (phone_number > 0 || phone_number != '') {
      $(`${get_id}`).attr('required', true)
    } else {
      $(`${get_id}`).removeAttr('required')
    }
  }

  $("#language-bom-categories").change(function(){
    var language_name = $(this).find('option:selected').text();
    updateName(language_name);
  });

  function updateName(language_name){
    $("#name").val(language_name);
  }

  $('form').on('click', '.add_fields.time_periods_nested', function(event) {
    $('.datetimepicker').datetimepicker({
      format: "DD/MM/YYYY hh:mm A",
      icons: {
        time:'zmdi zmdi-time',
        date:'zmdi zmdi-calendar-alt',
        up:'zmdi zmdi-chevron-up',
        down:'zmdi zmdi-chevron-down',
        previous:'zmdi zmdi-chevron-left',
        next:'zmdi zmdi-chevron-right',
        today:'zmdi zmdi-calendar-check',
        clear:'zmdi zmdi-tag-close',
        close:'zmdi zmdi-close'
      }
    });
  });

  // Check all country
  $('#check_all_country').click(function() {
    $('#checkbox-country input:checkbox').not(this).prop('checked', this.checked);
  })

  $('#checkbox-country input:checkbox').change(function() {
    var country = []
    var data_country = $('#data-country').data('country')
    $('#checkbox-country input:checkbox:checked').each(function(i) {
      country[i] = $(this).is(':checked')
      if (country.length == data_country ) {
        $('#check_all_country').prop('checked', true)
      } else {
        $('#check_all_country').prop('checked', false)
      }
    })
  })

  // Check all language
  $('#check_all_language').click(function() {
    $('#checkbox-language input:checkbox').not(this).prop('checked', this.checked);
  })

  $('#checkbox-language input:checkbox').change(function() {
    var language = []
    var data_language = $('#data-language').data('language')
    $('#checkbox-language input:checkbox:checked').each(function(i) {
      language[i] = $(this).is(':checked')
      if ( language.length == data_language ) {
        $('#check_all_language').prop('checked', true)
      } else {
        $('#check_all_language').prop('checked', false)
      }
    })
  })

  $('#checkbox-language input:checkbox').change(function() {
    if ($('#checkbox-language input:checkbox:checked').length == 0) {
      $('#checkbox-language input:checkbox').prop('required', true)
    } else {
      $('#checkbox-language input:checkbox').prop('required', false)
    }
  }).change()

  // Check all bom subscription details
  $('#check_all_subscribers').click(function() {
    $('#checkbox-subscribers input:checkbox').not(this).prop('checked', this.checked);
  })

  $('#checkbox-subscribers input:checkbox').change(function() {
    var subscribers = []
    var data_subscribers = $('#data-bom-subscription-details').data('bom-subscription-details')
    $('#checkbox-subscribers input:checkbox:checked').each(function(i) {
      subscribers[i] = $(this).is(':checked')
      if ( subscribers.length == data_subscribers ) {
        $('#check_all_subscribers').prop('checked', true)
      } else {
        $('#check_all_subscribers').prop('checked', false)
      }
    })
  })

  $('#checkbox-subscribers input:checkbox').change(function() {
    if ($('#checkbox-subscribers input:checkbox:checked').length == 0) {
      $('#checkbox-subscribers input:checkbox').prop('required', true)
    } else {
      $('#checkbox-subscribers input:checkbox').prop('required', false)
    }
  })

  setTimeout(() => {
    $('.multiple-select2').find('.select2-selection--multiple').addClass('select2-container-size');
    $('.multiple-select2').find('.select2-container--default').addClass('select2-size');
  }, 10);
})